import { Appointment, AppointmentResponseAppointment } from './appointment'
import { TimeBlock } from './availability'
import { ResourceId } from './resource'

enum UnavailabilityType {
  CALENDAR_INTEGRATION_BUSY = 'CALENDAR_INTEGRATION_BUSY',
  CALENDAR_INTEGRATION_NON_WORKING_HOURS = 'CALENDAR_INTEGRATION_NON_WORKING_HOURS',
  EXISTING_APPOINTMENT = 'EXISTING_APPOINTMENT',
  NOT_WITHIN_COMPANY_WORKING_HOURS = 'NOT_WITHIN_COMPANY_WORKING_HOURS',
  SCHEDULE_BLOCKED_FOR_ANOTHER_APPOINTMENT_TYPE = 'SCHEDULE_BLOCKED_FOR_ANOTHER_APPOINTMENT_TYPE',
  SCHEDULE_BLOCKED_UNAVAILABLE = 'SCHEDULE_BLOCKED_UNAVAILABLE',
  SCHEDULE_NOT_DEFINED_UNAVAILABLE_BY_DEFAULT = 'SCHEDULE_NOT_DEFINED_UNAVAILABLE_BY_DEFAULT',
}

interface WorkingHours {
  days?: string[] | null
  start?: string | null
  end?: string | null
  timezone?: string | null
}

type RelatedEntity = {
  appointment?: Appointment
  block: TimeBlock
  email?: string
  working_hours?: WorkingHours
}

interface Unavailability {
  block: TimeBlock
  related_entity?: RelatedEntity
  type: string
}

type RelatedEntityResponse = {
  appointment?: AppointmentResponseAppointment
  block: TimeBlock
  email?: string
  working_hours?: WorkingHours
}

interface UnavailabilityResponse {
  block: TimeBlock
  related_entity?: RelatedEntityResponse
  type: string
}

type UnavailabilitiesResponse = Record<ResourceId, UnavailabilityResponse[]>
type Unavailabilities = Record<ResourceId, Unavailability[]>

export type { UnavailabilitiesResponse, Unavailabilities, Unavailability }
export { UnavailabilityType }
